/**
 * "Install the game" helpers: iOS has no install prompt, so Safari players get told to use
 * Chia sẻ › Thêm vào MH chính (InstallHint, Settings); Android players get the APK.
 */

/** iPhone, iPod or iPad (iPadOS reports itself as a Mac with a touch screen). */
export function isIos(
  nav: Pick<Navigator, 'userAgent' | 'platform' | 'maxTouchPoints'> = navigator,
): boolean {
  return /iPad|iPhone|iPod/.test(nav.userAgent) || (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1);
}

/** Running from the home screen (PWA), not in a browser tab. */
export function isStandalone(win: Window = window): boolean {
  return (
    (win.navigator as Navigator & { standalone?: boolean }).standalone === true ||
    win.matchMedia('(display-mode: standalone)').matches
  );
}

/** The web game on iOS, still in a browser tab: worth suggesting "Thêm vào MH chính". */
export function canAddToHomeScreen(win: Window = window): boolean {
  return __PLATFORM__ === 'web' && isIos(win.navigator) && !isStandalone(win);
}
